import {useListFilterValues} from "../../../../hooks/hooks";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {FilterContentType, TableFilter} from "../../../../types/tableFilter";
import {OrganManagerShareFilterWordType, OrganShareFilterWordType} from "../../../../types/organShare";
import {useOrganManagerShareConverter} from "./useOrganManagerShareConverter";

interface Args {
    search: () => void;
}

export function useOrganManagerShareFilters({search}: Args) {
    const {t} = useTranslation(["filter", "common"]);
    const {filterValues} = useListFilterValues();

    const {getSearchWordConverter} = useOrganManagerShareConverter();

    const searchWordTypeFilter = useMemo(
        () => filterValues.searchWordTypeFilterValue,
        [filterValues.searchWordTypeFilterValue]
    );
    const searchWordFilter = useMemo(() => filterValues.searchWordFilterValue, [filterValues.searchWordFilterValue]);

    const filters: TableFilter[][] = [
        [
            {
                labelTitle: "검색어",
                content: {
                    type: FilterContentType.TEXT,
                    value: searchWordFilter?.value,
                    maxLength: 100,
                    placeholderVal: t("searchWord.placeholder"),
                    onChangeFunc: (v) => searchWordFilter.setter(v),
                    onEnterKeyUpFunc: search,
                    typeSelector: {
                        type: FilterContentType.SELECT,
                        value: searchWordTypeFilter?.value,
                        options: [
                            {label: "전체", value: ""},
                            {
                                value: OrganShareFilterWordType.MANAGER_NAME,
                                label: getSearchWordConverter(OrganManagerShareFilterWordType.MANAGER_NAME),
                            },
                            {
                                value: OrganShareFilterWordType.CELL_PHONE,
                                label: getSearchWordConverter(OrganManagerShareFilterWordType.CELL_PHONE),
                            },
                            {
                                value: OrganShareFilterWordType.ID,
                                label: getSearchWordConverter(OrganManagerShareFilterWordType.MANAGER_ID),
                            },
                        ],
                        onChangeFunc: (v) => searchWordTypeFilter?.setter(v as OrganShareFilterWordType),
                    },
                },
            },
        ],
    ]

    return{
        filters
    }
}